<template>
  <div class="md:-mb-4">
    <ProductBadge
      v-if="product.isSoldOut"
      class="left-0 top-0 ml-0"
      :badge-label="badgeLabel"
    />
    <h1 class="font-semibold">
      <div class="flex flex-row justify-between">
        <NuxtLink
          v-if="productBrand && brandPath"
          :to="brandPath"
          class="block text-sm uppercase hover:underline"
          data-qa="product-brand-link"
        >
          {{ productBrand }}
        </NuxtLink>
        <span v-else-if="productBrand" class="block text-sm uppercase">
          {{ productBrand }}
        </span>
        <span
          v-if="productOrderNumber"
          class="hidden text-sm text-gray-secondary md:block"
        >
          {{ $t('pdp.main_order_number') }}
          <span data-test-id="product-order-number">{{
            productOrderNumber
          }}</span>
        </span>
      </div>
      <span
        ref="productNameRef"
        class="leading-2 text-2lg sm:text-xl"
        data-qa="product-description"
      >
        {{ productName }}
      </span>
    </h1>
  </div>
</template>

<script setup lang="ts">
// TODO: Use alternative approach for badge label
import type { Product } from '@scayle/storefront-nuxt'
import { useI18n } from 'vue-i18n'
import type { HyphenatedOrderNumber } from '~/types/product'
import { getBadgeLabel } from '~/utils/product'
import { getBrandCategoryUrl } from '~/utils/route'

const i18n = useI18n()
const localePath = useLocalePath()

const props = defineProps({
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
  productName: {
    type: String,
    required: true,
  },
  productBrand: {
    type: String,
    required: true,
  },
  productOrderNumber: {
    type: String as PropType<HyphenatedOrderNumber>,
    default: '',
  },
})

const badgeLabel = computed(() => {
  const label = getBadgeLabel({ isSoldOut: props.product.isSoldOut })
  return i18n.t(`badge_labels.${label}`)
})

const brandPath = computed(() => {
  const iso = i18n.localeProperties.value.iso
  const path = getBrandCategoryUrl(
    props.product.categories,
    typeof iso === 'string' ? iso : undefined,
  )
  return path ? localePath(path) : ''
})
</script>
